function _classPrivateFieldLooseBase(e, t) { if (!{}.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance"); return e; }
var id = 0;
function _classPrivateFieldLooseKey(e) { return "__private_" + id++ + "_" + e; }
import { Component } from '@theme/component';

/** @typedef {typeof globalThis} Window */

/**
 * A component that handles title truncation with responsive behavior
 *
 * @typedef {Object} Refs
 * @property {HTMLElement} [text] - The text element to truncate (optional)
 *
 * @extends {Component<Refs>}
 */
var _initializeTruncation = _classPrivateFieldLooseKey("initializeTruncation");
var _calculateTruncation = _classPrivateFieldLooseKey("calculateTruncation");
var _handleResize = _classPrivateFieldLooseKey("handleResize");
class ProductTitle extends Component {
  constructor() {
    super();
    /**
     * Handle window resize events
     */
    Object.defineProperty(this, _handleResize, {
      value: _handleResize2
    });
    /**
     * Calculate truncation for the title
     */
    Object.defineProperty(this, _calculateTruncation, {
      value: _calculateTruncation2
    });
    /**
     * Initialize the title truncation
     */
    Object.defineProperty(this, _initializeTruncation, {
      value: _initializeTruncation2
    });
  }
  connectedCallback() {
    super.connectedCallback();
    _classPrivateFieldLooseBase(this, _initializeTruncation)[_initializeTruncation]();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    window.removeEventListener('resize', _classPrivateFieldLooseBase(this, _handleResize)[_handleResize]);
  }
}
function _initializeTruncation2() {
  if ('ResizeObserver' in window) {
    this.resizeObserver = new ResizeObserver(() => {
      _classPrivateFieldLooseBase(this, _calculateTruncation)[_calculateTruncation]();
    });
    this.resizeObserver.observe(this);
    _classPrivateFieldLooseBase(this, _calculateTruncation)[_calculateTruncation]();
  } else {
    /** @type {Window} */
    window.addEventListener('resize', _classPrivateFieldLooseBase(this, _handleResize)[_handleResize].bind(this));
    _classPrivateFieldLooseBase(this, _calculateTruncation)[_calculateTruncation]();
  }
}
function _calculateTruncation2() {
  /** @type {HTMLElement} */
  const textElement = this.refs.text || this.querySelector('.title-text') || this;
  if (!textElement.textContent) return;
  const containerHeight = this.clientHeight;
  const computedStyle = window.getComputedStyle(this);
  const lineHeight = parseFloat(computedStyle.lineHeight);
  const paddingTop = parseFloat(computedStyle.paddingTop);
  const paddingBottom = parseFloat(computedStyle.paddingBottom);
  const availableHeight = containerHeight - paddingTop - paddingBottom;
  const maxLines = Math.max(1, Math.floor(availableHeight / lineHeight));
  textElement.style.display = '-webkit-box';
  textElement.style.webkitBoxOrient = 'vertical';
  textElement.style.overflow = 'hidden';
  textElement.style.textOverflow = 'ellipsis';
  textElement.style.webkitLineClamp = String(maxLines);
}
function _handleResize2() {
  _classPrivateFieldLooseBase(this, _calculateTruncation)[_calculateTruncation]();
}
if (!customElements.get('product-title')) {
  customElements.define('product-title', ProductTitle);
}
export default ProductTitle;
